<template>
    <section class="filter-section">
        <div class="loading-container" v-if="loading">
            <Loading />
        </div>
        <div class="filters" v-else>
            <div class="filter-row" v-if="searchFilterIndex !== -1">
                <form
                    class="search-cluster"
                    id="publicationsSearchForm"
                    @submit.prevent="
                        $store.dispatch('updateFilterValue', {
                            type: 'search',
                            filterIndex: searchFilterIndex,
                            value: searchQuery,
                        })
                    "
                >
                    <div class="form-group">
                        <label for="publicationsSearch"
                            >Search by keyword</label
                        >
                        <div class="publications-search d-flex">
                            <input
                                type="search"
                                class="search-input"
                                role="search"
                                id="publicationsSearch"
                                autocomplete="off"
                                v-model="searchQuery"
                                @keyup:escape="
                                    $store.dispatch('updateFilterValue', {
                                        type: 'search',
                                        filterIndex: searchFilterIndex,
                                        clear: true,
                                    })
                                "
                            />
                            <button
                                type="reset"
                                class="autocomplete__reset hidden"
                                data-inputid="publicationsSearch"
                                aria-label="clear search field"
                                @click="
                                    $store.dispatch('updateFilterValue', {
                                        type: 'search',
                                        filterIndex: 0,
                                        clear: true,
                                    })
                                "
                            >
                                <span
                                    class="far fa-times"
                                    title="Clear search field"
                                ></span>
                            </button>
                            <button
                                type="submit"
                                class="search-submit"
                                data-inputid="<?php echo $id; ?>"
                                aria-label="submit search"
                            >
                                <span class="sr-only">Search</span>
                                <svg>
                                    <use xlink:href="#searchIcon"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <h2 class="section-header">Filter by</h2>
            <div class="filter-row">
                <div
                    class="app-filter-modal filter"
                    v-for="(filter, filterIndex) in filters"
                    :key="`filter-${filterIndex}`"
                >
                    <button
                        class="filter-button btn btn-secondary"
                        :class="{
                            active: filter.state,
                            'has-active-filters':
                                filterCount[filter.name] > 0 ||
                                (filter.type == 'date' && filter.value),
                        }"
                        @click="filter.state = !filter.state"
                        ref="trigger"
                    >
                        {{ filter.name }}
                        {{
                            filterCount[filter.name] !== 0
                                ? `(${filterCount[filter.name]})`
                                : null
                        }}
                    </button>

                    <BaseModal
                        :trigger="$refs.trigger[filterIndex]"
                        v-if="filter.state"
                        @clear-all="
                            $store.dispatch('updateFilterValue', {
                                type: filter.type,
                                filterIndex: filterIndex,
                                clearAll: true,
                            });
                            $store.dispatch('changeFilterState', {
                                index: filterIndex,
                                action: 'close',
                            });
                        "
                        @close="
                            $store.dispatch('changeFilterState', {
                                index: filterIndex,
                                action: 'close',
                            })
                        "
                        :modalTitle="filter.name"
                    >
                        <template v-if="filter.type == 'list'">
                            <fieldset>
                                <Checkbox
                                    v-for="(option,
                                    optionIndex) in filter.value"
                                    :key="`option-${option.value}-${option.id}`"
                                    :label="option.value"
                                    :checked="filter.value[optionIndex].active"
                                    @change="
                                        $store.dispatch('updateFilterValue', {
                                            type: filter.type,
                                            filterIndex: filterIndex,
                                            optionIndex: optionIndex,
                                        })
                                    "
                                />
                            </fieldset>
                        </template>
                        <DatePicker
                            :value="filter.value"
                            v-bind="filter"
                            @input="
                                $store.dispatch('updateFilterValue', {
                                    type: filter.type,
                                    value: $event,
                                    filterIndex: filterIndex,
                                })
                            "
                            :numYearsPastToShow="10"
                            :numYearsFutureToShow="0"
                            @close="
                                $store.dispatch('changeFilterState', {
                                    index: filterIndex,
                                    action: 'close',
                                })
                            "
                            @clear="
                                $store.dispatch('updateFilterValue', {
                                    type: filter.type,
                                    filterIndex: filterIndex,
                                    clear: true,
                                });
                                $store.dispatch('changeFilterState', {
                                    index: filterIndex,
                                    action: 'close',
                                });
                            "
                            v-else
                        />
                    </BaseModal>
                </div>
            </div>

            <div class="filter-row">
                <div
                    class="active-filters-section"
                    v-if="activeFilters.length > 0"
                >
                    <div class="section-header total-results">
                        Found {{ totalResults }} results filtered by:
                    </div>
                    <div class="filter-row active-filters">
                        <button
                            v-for="({ name, value, type, filterIndex },
                            index) in activeFilters"
                            :key="'activefilter-' + index"
                            class="pill pill-outline cancel-filter"
                            @click="
                                $store.dispatch('updateFilterValue', {
                                    type: type,
                                    filterIndex,
                                    optionIndex: value.optionIndex,
                                    clear: true,
                                })
                            "
                        >
                            {{ name }}: {{ value.value || value }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BaseModal from '@/components/wrappers/BaseModal';
import DatePicker from '@/components/inputs/DatePicker';
import Checkbox from '@/components/inputs/Checkbox';
import Loading from '@/components/Loading';

export default {
    components: {
        BaseModal,
        Loading,
        DatePicker,
        Checkbox,
    },
    computed: {
        filters() {
            return this.$store.getters.filters.filter(
                (filter) => filter.type !== 'search'
            );
        },
        searchFilterIndex() {
            const filterList = this.$store.getters.filters;

            for (let i = 0; i < filterList.length; i++) {
                if (filterList[i].name == 'Search') {
                    return i;
                }
            }

            return -1;
        },
        searchQuery: {
            get() {
                return this.$store.getters.searchQuery;
            },
            set(event) {
                this.$store.dispatch('updateSearchQuery', {
                    value: event,
                });
            },
        },
        activeFilters() {
            return this.$store.getters.activeFilters;
        },
        filterCount() {
            const filterCount = {};

            this.filters.forEach((filter) => {
                if (filter.type == 'list') {
                    filterCount[filter.name] = 0;
                    filter.value.forEach((value) => {
                        if (value.active) filterCount[filter.name]++;
                    });
                } else {
                    filterCount[filter.name] = 0;
                }
            });

            return filterCount;
        },
        loading() {
            return this.$store.getters.loading('filters');
        },
        totalResults() {
            return this.$store.getters.totalPosts;
        },
    },
};
</script>
